var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-12 col-lg-12 content mb-20 mb-lg-0"},[_c('h1',{staticClass:"text-center"},[_vm._v("\n    404 Page not found\n  ")])])
}]

export { render, staticRenderFns }